import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthResponse } from 'app/models/auth-response';
import { UserDto } from 'app/models/user-dto';
import { loginByAdmin, UserLoginDto } from 'app/models/user-login-dto';
import { Observable, tap } from 'rxjs';

export interface UpdateUserFlagsDto {
  status?: boolean;
  banned?: boolean;
}
export interface UpdateUserRequest {
  userId: number;
  name?: string;
  oldPassword?: string;
  newPassword?: string;
  phone?: string;
  code?: string;
}


@Injectable({
  providedIn: 'root'
})
export class UserService {
    private get apiUrl(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + "/api/v2" ;
  }
  constructor(private http:HttpClient) { }

  getUsers(type : string): Observable<UserDto[]> {
          return this.http.get<UserDto[]>(`${this.apiUrl}/users?type=${type}`);
        }
  loginUserByAdmin(user:loginByAdmin): Observable<any> {
         return this.http.post<AuthResponse>(`${this.apiUrl}/auth/loginByAdmin`, user, { withCredentials: true })
    .pipe(
      tap(res => {
        if (res.access_token) {
          console.log(res.access_token);
        }
      })
    );
}
createUser(payload: any): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/users`, payload);
}


updateUserFlags(id: number, dto: UpdateUserFlagsDto): Observable<any> {
  return this.http.put<any>(
    `${this.apiUrl}/users/${id}/flags`,
    dto
  );
}
updateProfile(request: UpdateUserRequest): Observable<any> {
  return this.http.post<any>(
    `${this.apiUrl}/users/update-profile`,
    request
  );
}

deleteUser(id: number): Observable<any> {
  return this.http.delete<any>(
    `${this.apiUrl}/users/delete/${id}`
  );
}
}
